import { Component, OnInit } from "@angular/core";
import { first } from "rxjs/operators";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import * as Highcharts from "highcharts";
import { ChartViewDTO } from "src/app/new-dashboard/core/model/chart_view/chart-view-dto";
import { NewDashboardProfessionnelService } from "src/app/new-dashboard/core/service/new-dashboard-professionnel.service";
import { DashboardAllMarcheService } from "src/app/new-dashboard/core/service/dashboard-all-marche.service";
import { DurationByProduitDTO } from "src/app/new-dashboard/core/model/duration-by-produit-dto";
import { SlaProduitDTO } from "src/app/new-dashboard/core/model/sla-produit-dto";
import { DurationByTaskDTO } from "src/app/new-dashboard/core/model/duration-by-task-dto";
import { Bank } from "src/app/parametrage/core/model/bank";
import { City } from "src/app/parametrage/core/model/city";
import { BankService } from "src/app/parametrage/core/service/bank.service";
import { CityService } from "src/app/parametrage/core/service/city.service";

@Component({
  selector: "app-prof-qos",
  templateUrl: "./prof-qos.component.html",
  styleUrls: ["./prof-qos.component.scss"],

  //
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
  //
})
export class ProfQosComponent implements OnInit {
  cityFilter: String = "_";
  bankFilter: String = "_";

  banks: Bank[];
  cities: City[];

  highcharts = Highcharts;
  chartOptionsProduitByPeriode: any;
  chartOptionsSlaPeriodeParProfile: any;
  //chartOptionsSlaTacheParProduit: any;

  produitByPeriode: ChartViewDTO;
  slaPeriodeParProfile: ChartViewDTO;
  slaTacheParProduit: ChartViewDTO;

  durationByProduitDTOs: DurationByProduitDTO[];
  displayedProduitColumnsList: string[] = [
    "codeProduit",
    "qtyRequest",
    "duration",
    "actions",
  ];
  durationByTaskDTOs: DurationByTaskDTO[];
  durationByTaskDTOArray: Array<DurationByTaskDTO[]> = [];

  //slaProduitDTOs: SlaProduitDTO[];

  constructor(
    private _newDashboardProfessionnelService: NewDashboardProfessionnelService,
    private _dashboardAllMarcheService: DashboardAllMarcheService,
    private _bankService: BankService,
    private _cityService: CityService
  ) {}

  ngOnInit() {
    this.getAllCities();
    this.getAllBanksByCity("_");
    this.slaProduitParPeriode("_");
    this.getSlaPeriodeParProfile("_");
    //this.getSlaTacheParProduit("_");
    this.durationProduit("_");
    //this.getSlaProduit("_");
  }

  getAllCities() {
    this._cityService
      .getAllCities()
      .pipe(first())
      .subscribe(
        (data) => {
          this.cities = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getAllBanksByCity(city) {
    this._bankService
      .getAllBanksByCity(city)
      .pipe(first())
      .subscribe(
        (data) => {
          this.banks = data;
          this.bankFilter = "_";
        },
        (error) => {
          console.log(error);
        }
      );
  }

  refresh(codeAgence) {
    this.slaProduitParPeriode(codeAgence);
    this.getSlaPeriodeParProfile(codeAgence);
    //this.getSlaTacheParProduit(codeAgence);
    this.durationProduit(codeAgence);
    //this.getSlaProduit(codeAgence);
  }

  slaProduitParPeriode(codeAgence) {
    this._newDashboardProfessionnelService
      .slaProduitParPeriode(codeAgence)
      .pipe(first())
      .subscribe(
        (response) => {
          this.produitByPeriode = response;

          this.chartOptionsProduitByPeriode = {
            chart: {
              type: "spline",
            },
            title: {
              text: "Temps de traitement moyen des produits sur les 6 derniers mois",
            },
            subtitle: {
              text: null,
            },
            xAxis: {
              categories: this.produitByPeriode.categories,
            },
            yAxis: {
              title: {
                text: "Jour(s)",
              },
            },
            tooltip: {
              valueSuffix: null,
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true,
            },

            series: this.produitByPeriode.series,
          };
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getSlaPeriodeParProfile(agency) {
    this._dashboardAllMarcheService
      .slaPeriodeParProfile("PROFESSIONNEL", agency)
      .pipe(first())
      .subscribe(
        (response) => {
          this.slaPeriodeParProfile = response;

          this.chartOptionsSlaPeriodeParProfile = {
            chart: {
              type: "spline"
            },
            title: {
              text: "Temps de traitement par profil sur les 6 derniers mois"
            },
            subtitle: {
              text: null
            },
            xAxis: {
              categories: this.slaPeriodeParProfile.categories
            },
            yAxis: {
              title: {
                text: "Jours"
              }
            },
            tooltip: {
              valueSuffix: null
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true
            },

            series: this.slaPeriodeParProfile.series
          };
        },
        (error) => {
          console.log(error);
        }
      );
  }

  /*
  getSlaTacheParProduit(codeAgence) {
    this._dashboardAllMarcheService
      .slaTacheParProduit("PROFESSIONNEL", codeAgence)
      .pipe(first())
      .subscribe(
        (response) => {
          this.slaTacheParProduit = response;

          this.chartOptionsSlaTacheParProduit = {
            chart: {
              type: "bar",
            },
            title: {
              text: "SLA tâches par produit",
            },
            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true,
            },
            xAxis: {
              categories: this.slaTacheParProduit.categories,
              title: {
                text: null,
              },
            },
            yAxis: {
              min: 0,
              title: {
                text: "Jours",
                align: "high",
              },
              labels: {
                overflow: "justify",
              },
            },
            tooltip: {
              valueSuffix: "",
            },
            plotOptions: {
              bar: {
                dataLabels: {
                  enabled: true,
                },
                showInLegend: true,
              },
              series: {
                stacking: "normal",
              },
            },
            credits: {
              enabled: false,
            },
            series: this.slaTacheParProduit.series,
          };
        },
        (error) => {
          console.log(error);
        }
      );
  }
  */

  durationProduit(codeAgence) {
    this._dashboardAllMarcheService
      .durationProduit("PROFESSIONNEL", codeAgence)
      .subscribe(
        (data) => {
          this.durationByProduitDTOs = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  durationTask(codeProduit) {
    this._dashboardAllMarcheService
      .durationTaskByProduit(codeProduit)
      .subscribe(
        (data) => {
          this.durationByTaskDTOs = data;
          this.durationByTaskDTOArray[codeProduit] = this.durationByTaskDTOs;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  /*getSlaProduit(codeAgence) {
    this._dashboardAllMarcheService
      .slaProduit("PROFESSIONNEL", codeAgence)
      .pipe(first())
      .subscribe(
        (response) => {
          this.slaProduitDTOs = response;
        },
        (error) => {
          console.log(error);
        }
      );
  }*/
}
